import { writable } from 'svelte/store';
import { api } from '$lib/api/client';

export interface RoleInfo {
  role: string;
  kepkId: string | null;
}

export interface User {
  id: string;
  publicId: string;
  username: string;
  displayName: string;
  email: string;
  emailVerified: boolean;
  mfaEnabled: boolean;
  roles: RoleInfo[];
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  error: string | null;
}

function createAuthStore() {
  const { subscribe, set, update } = writable<AuthState>({
    user: null,
    isAuthenticated: false,
    loading: true,
    error: null,
  });

  return {
    subscribe,
    async load() {
      set({ user: null, isAuthenticated: false, loading: true, error: null });
      try {
        const data = await api.get<{ user: User }>('/me');
        set({ user: data.user, isAuthenticated: true, loading: false, error: null });
      } catch {
        set({ user: null, isAuthenticated: false, loading: false, error: null });
      }
    },
    async login(username: string, password: string) {
      update((s) => ({ ...s, loading: true, error: null }));
      try {
        const data = await api.post<{ user: User; csrfToken: string }>('/auth/login', {
          username,
          password,
        });
        api.setCsrf(data.csrfToken);
        set({ user: data.user, isAuthenticated: true, loading: false, error: null });
        return true;
      } catch (e) {
        const message = e instanceof Error ? e.message : 'Login gagal';
        set({ user: null, isAuthenticated: false, loading: false, error: message });
        return false;
      }
    },
    async logout() {
      try {
        await api.post('/auth/logout');
      } catch {
        // ignore
      }
      api.setCsrf(null);
      set({ user: null, isAuthenticated: false, loading: false, error: null });
    },
  };
}

export const authStore = createAuthStore();
